document.addEventListener('DOMContentLoaded', function () {
  function initImageClickZoom() {
    const mediaItems = document.querySelectorAll('.product-gallery__media[data-media-type="image"]');

    mediaItems.forEach(function (item) {
      if (item.dataset.zoomBound) return;
      item.dataset.zoomBound = 'true';

      item.style.cursor = 'zoom-in';

      item.addEventListener('click', function (e) {
        const zoomBtn = item.querySelector('button[is="product-zoom-button"]');
        if (zoomBtn && !zoomBtn.contains(e.target)) {
          zoomBtn.click();
        }
      });
    });
  }

  initImageClickZoom();

  document.querySelectorAll('.product-gallery__media').forEach(function (el) {
    el.addEventListener('click', function () {
      setTimeout(initImageClickZoom, 300);
    });
  });
});